import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import SideMenu from "./common/sideMenu";
import { Container } from "../common/styled";
import { SectionContainer } from "./component/styled";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { useModal } from "../../../hooks/useModal";
import useUserAuthActions from "../../../hooks/useUserStorage";

const ShoppingMyPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { checkAndLogin } = useUserAuthActions();

  const { modal, openModal, closeModal } = useModal();

  const isIndex = location.pathname === `/shop/mypage` || location.pathname === `/shop/mypage/`;
  const viewSideMenu = !isMobile || isIndex;

  useEffect(() => {
    const checkAuth = async () => {
      const isLoggedIn = await checkAndLogin();
      if (!isLoggedIn) {
        toast.error("로그인 후 이용 가능합니다.", { toastId: "no-access" });
        const path = location.pathname.split("/mypage")[1];
        navigate(`/shop/login`, {
          state: { path: `mypage${path || ""}` },
        });
      }
    };

    checkAuth();
  }, [checkAndLogin, navigate, location.pathname]);

  const tabs = [
    {
      label: "나의 주문관리",
      items: [
        { label: "주문/배송조회", key: "history" },
        { label: "장바구니", key: "cart" },
      ],
    },
    {
      label: "개인정보관리",
      items: [
        { label: "회원정보수정", key: "profile" },
        { label: "배송지 관리", key: "address" },
      ],
    },
  ];

  return (
    <Container className={`theme-${theme}`}>
      {modal}
      <SectionContainer className={`theme-${theme}`}>
        {viewSideMenu && <SideMenu tabs={tabs} />}
        <Outlet context={{ openModal, closeModal }} />
      </SectionContainer>
    </Container>
  );
};

export default ShoppingMyPage;
